module.exports = __webpack_public_path__ + "static/img/logo08.64dfad2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo08.jpg
// module id = qMJX
// module chunks = 1